import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Carousel, Badge, notification, Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/pro-solid-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import {
	checkPermissions,
	deleteFile,
	readFile,
	useRequestPublicStoragePermissions,
	setFileStorage,
} from "../../../providers/useCapacitorStorage";
import SurveyList from "./SurveyList";
import { userData } from "../../../providers/companyInfo";

export default function PageDashboard() {
	const navigate = useNavigate();

	useRequestPublicStoragePermissions();

	const [formList, setFormList] = useState([]);
	const [surveyPendingList, setSurveyPendingList] = useState([]);

	console.log("surveyPendingList::: ", surveyPendingList);
	// console.log("user_id:::", userData());

	const recountPendingList = useCallback(async () => {
		try {
			const resCheckPermissions = await checkPermissions();

			if (resCheckPermissions?.publicStorage === "granted") {
				let resReadFile = await readFile(
					`fsuu_dsac_survey_diosys/survey_pending_list_${userData().id}.txt`,
				);

				if (resReadFile?.data) {
					const parsed = JSON.parse(resReadFile.data);
					setSurveyPendingList(Array.isArray(parsed) ? parsed : []);
				} else {
					setSurveyPendingList([]);
				}
			}
		} catch (err) {
			console.error("Error reading survey pending list:", err);
			setSurveyPendingList([]);
		}
	}, []);

	GET(
		`api/form?from=SurveyMobile`,
		"form_list",
		async (res) => {
			if (res?.data) {
				let data = res.data;

				let datasync = document.getElementById("datasync");
				if (datasync) datasync.classList.remove("hide");

				let dataSurveyFiltered = data.filter(
					(f) => f.form_question_categories.length > 0,
				);

				setFormList(dataSurveyFiltered);

				let resCheckPermissions = await checkPermissions();

				if (resCheckPermissions?.publicStorage === "granted") {
					let resSetFileStorage = await setFileStorage(
						"fsuu_dsac_survey_diosys",
						"form_list",
						dataSurveyFiltered,
					);

					if (resSetFileStorage?.uri) {
						setTimeout(() => {
							if (datasync) datasync.classList.add("hide");
						}, 1000);
					} else {
						let resDeleteFile = await deleteFile(
							"fsuu_dsac_survey_diosys/form_list.txt",
						);

						if (resDeleteFile) {
							notification.error({
								message: "Delete Survey List",
								description: JSON.stringify(resDeleteFile),
							});
						} else {
							await setFileStorage(
								"fsuu_dsac_survey_diosys",
								"form_list",
								dataSurveyFiltered,
							);

							if (datasync) datasync.classList.add("hide");
						}
					}
				}
			}
		},
		false,
	);

	useEffect(() => {
		const handleReadFile = async () => {
			try {
				const resCheckPermissions = await checkPermissions();

				if (resCheckPermissions?.publicStorage === "granted") {
					try {
						let resReadFile = await readFile(
							"fsuu_dsac_survey_diosys/form_list.txt",
						);

						if (resReadFile?.data) {
							setFormList(JSON.parse(resReadFile.data));
						}
					} catch (err) {
						console.error("Error reading form_list:", err);
					}

					await recountPendingList();
				}
			} catch (err) {
				console.error("Init load error:", err);
			}
		};

		handleReadFile();
	}, [recountPendingList]);

	useEffect(() => {
		const handler = () => {
			recountPendingList();
		};

		window.addEventListener("survey-pending-updated", handler);

		return () => {
			window.removeEventListener("survey-pending-updated", handler);
		};
	}, [recountPendingList]);

	return (
		<Card>
			<Row>
				<Col xs={24}>
					<Carousel className="intro" adaptiveHeight arrows>
						<div className="carousel-item-home">
							<img src="/assets/images/diosys-banner.png" alt="" />
						</div>
					</Carousel>
				</Col>

				<Col xs={24}>
					<Card
						className="survey-list-wrapper"
						title={
							<>
								<div className="title">SURVEY LIST</div>

								<div className="action cursor-pointer">
									{surveyPendingList.length > 0 && (
										<Badge
											count={surveyPendingList.length}
											overflowCount={99}
											onClick={() => navigate("/survey/pending")}
										>
											<FontAwesomeIcon
												icon={faSquare}
												style={{ color: "#2d60e2" }}
											/>
										</Badge>
									)}
								</div>
							</>
						}
					>
						<SurveyList formList={formList} />
					</Card>
				</Col>
			</Row>
		</Card>
	);
}
